<template>
  <div
    v-if="!vm.isMobile"
    ref="menus"
    :class="['nav', { 'nav-open': isOpen, 'nav-scroll-hide': isScrollDown }]"
    @click.prevent="isOpen = !isOpen"
  >
    <div class="content">
      <img src="../../assets/banner/close.png" class="logo-close" alt="ColorOS 11 OPPO" />
      <img src="../../assets/banner/top.png" class="logo-top" alt="ColorOS 11 OPPO" @click="goAnchor('kv-banner')" />
      <div class="nav-line nav-line1"></div>
      <div class="anchor-wrap">
        <div v-for="(item, index) in menus" :key="index" class="nav-anchor" @click="goAnchor(item.id)">
          <div class="circle"></div>
          <div class="bubble">
            <img :src="require(`../../assets/banner/${item.id}.jpg`)" class="logo-kv" alt />
            <span class="tit">{{ item.name }}</span>
            <div class="triangle-right"></div>
          </div>
        </div>
      </div>
      <div class="nav-line"></div>
    </div>
    <div class="logo-breeno">
      <img v-if="lang === 'zh'" src="../../assets/banner/nav-breeno.png" alt="ColorOS 11 OPPO" />
      <img v-else src="../../assets/banner/nav-logo-f.jpg" alt="ColorOS 11 OPPO" />
    </div>
  </div>
</template>
<script>
import Controller from '../../util/scrollMagic';
let zhAnchor = [
  {
    name: '个性化创造',
    id: 'personality'
  },
  {
    name: '轻松高效',
    id: 'highEfficiency'
  },
  {
    name: '畅快体验',
    id: 'fluent'
  },
  {
    name: '三方开放',
    id: 'photography'
  },
  {
    name: '隐私安全',
    id: 'privacy'
  },
  {
    name: '更多',
    id: 'more-topic'
  }
];

let enAnchor = [
  {
    name: 'UI Design',
    id: 'personality'
  },
  {
    name: 'Efficiency',
    id: 'highEfficiency'
  },
  {
    name: 'Smoothness',
    id: 'fluent'
  },
  {
    name: 'Battery',
    id: 'power-saving'
  },
  {
    name: 'Data Privacy',
    id: 'privacy-cloud-infor'
  },
  {
    name: 'More',
    id: 'more-topic'
  }
];
export default {
  inject: ['vm', 'lang'],
  data() {
    return {
      isOpen: false,
      menus: [],
      scrollActionY: 'undefined',
      isScrollDown: false
    };
  },
  watch: {
    isOpen(newVal, oldVal) {
      let domStyle = this.$refs.menus.style;
      if (oldVal) {
        domStyle.overflow = 'hidden';
      } else {
        setTimeout(() => {
          domStyle.overflow = 'visible';
        }, 300);
      }
    }
  },
  mounted() {
    if (this.lang === 'zh') {
      this.menus = zhAnchor;
    } else {
      this.menus = enAnchor;
    }
    if (!this.vm.isMobile) {
      window.addEventListener('scroll', this.handleScroll, false);
    }
  },
  methods: {
    handleScroll() {
      this.isOpen = false;
      // if (window.pageYOffset < window.innerHeight * 0.75) return;
      // if (typeof this.scrollActionY == 'undefined') {
      //   this.scrollActionY = window.pageYOffset;
      // }
      // var diffY = this.scrollActionY - window.pageYOffset;
      // if (diffY < 0) {
      //   // Scroll down
      //   this.isOpen = false;
      //   this.isScrollDown = true;
      // } else if (diffY > 0) {
      //   // Scroll up
      //   this.isScrollDown = false;
      // }
      // this.scrollActionY = window.pageYOffset;
    },
    goAnchor(id) {
      Controller.scrollTo('#' + id);
      if (id === 'power-saving') {
        let offset = document.documentElement.scrollTop + screen.availHeight * 3.45;
        Controller.scrollTo(offset);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 734px) {
  .nav {
    display: none;
  }
}
.nav {
  position: fixed;
  width: 44px;
  height: 44px;
  overflow: hidden;
  background: #ffffff;
  border-radius: 50px;
  right: 60px;
  bottom: 50px;
  text-align: center;
  font-size: 0;
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.33, 0, 0.06, 1);
  animation: zoomIn 0.4s linear;
  z-index: 1000;
  .content {
    opacity: 0;
    transition: opacity 0.2s cubic-bezier(0.33, 0, 0.06, 1);
  }
  filter: drop-shadow(0px 8px 12px rgba(0, 0, 0, 0.08));
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.08);
  .logo-close,
  .logo-top {
    width: 24px;
    height: 24px;
    margin-top: 12px;
    cursor: pointer;
  }
  &-line {
    display: inline-block;
    width: 28px;
    border-top: 1px solid #f3f3f3;
  }
  &-line1 {
    margin-top: 12px;
  }
  &-anchor {
    position: relative;
    padding: 17px 0;
    .circle {
      position: relative;
      border-radius: 50%;
      width: 6px;
      height: 6px;
      background: #cccccc;
      margin: 0 auto;
      transition: background 0.2s cubic-bezier(0.33, 0, 0.06, 1);
      &::after {
        content: '';
        position: absolute;
        width: 16px;
        height: 16px;
        left: -5px;
        top: -5px;
        border-radius: 50%;
        opacity: 0;
        transition: opacity 0.2s cubic-bezier(0.33, 0, 0.06, 1);
      }
    }

    &:nth-child(1) .circle {
      &::after {
        background: #33da5c;
      }
    }
    &:nth-child(2) .circle {
      &::after {
        background: #5ac8ff;
      }
    }
    &:nth-child(3) .circle {
      &::after {
        background: #ffd93b;
      }
    }
    &:nth-child(4) .circle {
      &::after {
        background: #9e9e9e;
      }
    }
    &:nth-child(5) .circle {
      &::after {
        background: #8150d1;
      }
    }
    &:nth-child(6) .circle {
      &::after {
        background: #73c9ce;
      }
    }
    .bubble {
      display: flex;
      position: absolute;
      height: 19px;
      padding: 8px 0px;
      justify-content: center;
      background: #ffffff;
      box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.08);
      left: 0px;
      align-items: center;
      border-radius: 10px;
      top: 50%;
      /*! autoprefixer: off */
      -ms-transform: translateX(-100%) translateX(-6px) translateY(-50%);
      transform: translate(calc(-100% - 6px), -50%);
      opacity: 0;
      transition: all 0.2s cubic-bezier(0.33, 0, 0.06, 1);
      .logo-kv {
        width: 20px;
        height: 20px;
      }
      .tit {
        font-weight: 500;
        font-size: 12px;
        line-height: 125%;
        margin-left: 10px;
      }
      .triangle-right {
        display: inline-block;
        font-size: 0;
        overflow: hidden;
        position: absolute;
        top: 11px;
        right: -6px;
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
        box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.08);
      }
      .triangle-right:before {
        content: '';
        position: relative;
        display: inline-block;
        border: 6px solid transparent;
        left: 1px;
        border-right-width: 0;
        border-left-width: 8px;
        border-left-color: #fff;
      }
    }
  }
  &-anchor:hover {
    .bubble {
      opacity: 1;
      /*! autoprefixer: off */
      -ms-transform: translateX(-100%) translateX(-18px) translateY(-50%);
      transform: translate(calc(-100% - 18px), -50%);
      transition: all 0.2s cubic-bezier(0.33, 0, 0.06, 1);
    }
    .circle {
      background: #d2f1a5;
      transition: background 0.2s cubic-bezier(0.33, 0, 0.06, 1);
      &::after {
        opacity: 0.2;
        transition: opacity 0.2s cubic-bezier(0.33, 0, 0.06, 1);
      }
    }
    &:nth-child(1) .circle {
      background: #33da5c;
    }
    &:nth-child(2) .circle {
      background: #5ac8ff;
    }
    &:nth-child(3) .circle {
      background: #ffd93b;
    }
    &:nth-child(4) .circle {
      background: #9e9e9e;
    }
    &:nth-child(5) .circle {
      background: #8150d1;
    }
    &:nth-child(6) .circle {
      background: #73c9ce;
    }
  }
  .logo-breeno {
    z-index: 10;
    position: absolute;
    width: 44px;
    height: 44px;
    bottom: 15px;
    background: #fff;
    border-radius: 50%;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.nav-open {
  height: 370px;
  transition: height 0.2s cubic-bezier(0.33, 0, 0.06, 1);
  .content {
    opacity: 1;
    transition: opacity 0.2s cubic-bezier(0.33, 0, 0.06, 1);
  }
}
.nav-scroll-hide {
  bottom: -94px;
  opacity: 0;
  transition: all 0.2s linear;
}
html:not([lang|='zh']) {
  .nav-anchor {
    &:nth-child(1) .bubble {
      width: 107px;
    }
    &:nth-child(2) .bubble {
      width: 108px;
    }
    &:nth-child(3) .bubble {
      width: 123px;
    }
    &:nth-child(4) .bubble {
      width: 93px;
    }
    &:nth-child(5) .bubble {
      width: 127px;
    }
    &:nth-child(6) .bubble {
      width: 81px;
    }
  }
}
html[lang|='zh'] {
  .nav-anchor {
    &:nth-child(1) .bubble {
      width: 111px;
    }
    &:nth-child(2) .bubble {
      width: 100px;
    }
    &:nth-child(3) .bubble {
      width: 100px;
    }
    &:nth-child(4) .bubble {
      width: 100px;
    }
    &:nth-child(5) .bubble {
      width: 100px;
    }
    &:nth-child(6) .bubble {
      width: 76px;
    }
  }
}
@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}
</style>
